import Highcharts from 'highcharts';
import { useEffect, useRef, memo, useMemo, useCallback } from 'react';
import { getDefaultSettings } from '@components/ScatterChart/defaultSettings';
import { FCX, getScaledPixels, ID, useWindowSizeDebounced } from "@datassential/platform-ui-lib";

window.charts = window.charts ?? {};

const ScatterChart: FCX<{
    series: any[];
    onPointClick?: (id: ID | undefined) => void;
    height: number;
    id: string;
}> = ({
    series,
    height,
    onPointClick = () => {},
    id,
}) => {
    const elRef = useRef<HTMLDivElement>(null);
    const [wWidth] = useWindowSizeDebounced();

    const getScaledPxFn = useCallback(
        (px: number) => getScaledPixels(px, wWidth),
        [wWidth]
    );

    const defaultSettings = useMemo(
        () => getDefaultSettings(getScaledPxFn),
        [getScaledPxFn]
    );

    useEffect(() => {
        if (elRef.current) {

            setTimeout(() => {
                try {
                    window.charts[id] = Highcharts.chart({
                        ...defaultSettings,
                        chart: {
                            ...defaultSettings.chart,
                            height: getScaledPxFn(height),
                            renderTo: elRef.current,
                        },
                        series: series.map(i => ({
                            ...i,
                            marker: {
                                symbol: 'circle',
                            },
                            point: {
                                events: {
                                    mouseOver: (event: any) => {
                                        onPointClick(event?.target?.point?.id);
                                    },
                                    mouseOut: (event: any) => {
                                        onPointClick(undefined);
                                    },
                                }
                            }
                        })),
                    } as Highcharts.Options);
                } catch (err) {
                    console.log('chart error: ', err);
                }
            }, 100);

            return () => {
                try {
                window.charts[id]?.destroy();
                } catch (err) {
                    console.log('chart destroy error: ', err);
                }
            };
        }
    }, [elRef, series, height, getScaledPxFn, id, onPointClick, defaultSettings]);

    return (
        <div ref={elRef} style={{ height: getScaledPxFn(height) }}/>
    );
};

export default memo(ScatterChart);